<p class="disclaimer-text">
  Please ensure you have the rights to use any data or documents you provide.
  AI-generated content may contain inaccuracies. Always verify and cross-check
  with trusted sources before making decisions or taking action.
</p>
